const WORDS = ["Ascolto", "Empatia", "Consapevolezza", "Accoglienza", "Riservatezza", "Fiducia", "Rispetto"];

export const Marquee = () => {
    const row = [...WORDS, ...WORDS];
    return (
        <div className="overflow-hidden border-y border-ink/10 bg-sand/60 py-5" aria-hidden="true" data-testid="values-marquee">
            <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
                {row.map((w, i) => (
                    <span key={i} className="flex items-center gap-10 font-serif text-2xl sm:text-3xl italic text-petrol/50">
                        {w}
                        <span className="h-1.5 w-1.5 rounded-full bg-sage/60" />
                    </span>
                ))}
            </div>
        </div>
    );
};
